import React from "react";

interface ProposalsIconProps {
  fill?: string;
  size?: number | string;
}

const ProposalsIcon: React.FC<ProposalsIconProps> = ({ fill = "#fff", size }) => (
  <svg
    id="uuid-a6fdde0f-bb36-49e7-ac40-3456bbda3990"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 302.21 374.57"
    {...(size && { width: size, height: size })}
  >
    <defs>
      <style>{`.uuid-d2f3638e-a293-4e9f-856f-bc99a1772048 { fill: ${fill}; }`}</style>
    </defs>
    <g id="uuid-d53761c3-e928-418c-8151-876f847772b5" data-name="Layer 1">
      <g id="uuid-95035a7b-027f-403b-9df2-03fa416b5f6f" data-name="03-Proposals">
        <g>
          <path
            className="uuid-d2f3638e-a293-4e9f-856f-bc99a1772048"
            d="M276.94,112.62H22.27c-6.35,0-11.5-5.15-11.5-11.5s5.15-11.5,11.5-11.5h254.67c6.35,0,11.5,5.15,11.5,11.5s-5.15,11.5-11.5,11.5Z"
          />
          <path
            className="uuid-d2f3638e-a293-4e9f-856f-bc99a1772048"
            d="M151.83,374.57c-10.84,0-21.68-4.13-29.94-12.38-.45-.45-.86-.93-1.22-1.44L14.44,212.13s-.04-.06-.06-.09c-7.27-10.38-14.38-21.72-14.38-36.28v-62.94c0-11.65,3.59-22.8,10.38-32.26L56.6,16.16C63.87,6.04,75.64,0,88.09,0h126c12.2,0,23.82,5.84,31.1,15.63l46.08,61.96c7.07,9.5,10.95,21.26,10.93,33.1l-.09,66.64c0,15.39-7.74,27.57-14.53,36.48l-104.58,146.91c-.37.52-.79,1.01-1.24,1.46-8.25,8.25-19.09,12.38-29.94,12.38ZM173.63,354.05h0,0ZM138.76,346.5c7.37,6.76,18.75,6.76,26.12,0l104.07-146.19c.08-.1.15-.21.23-.31,6.87-8.99,9.93-15.99,9.93-22.7v-.02l.09-66.64c0-6.92-2.26-13.79-6.39-19.34l-46.08-61.96c-2.96-3.98-7.69-6.35-12.64-6.35h-126c-5.06,0-9.85,2.46-12.8,6.57L29.07,93.98c-3.97,5.53-6.07,12.05-6.07,18.85v62.94c0,7.15,3.58,13.61,10.18,23.03l105.58,147.71Z"
          />
          <path
            className="uuid-d2f3638e-a293-4e9f-856f-bc99a1772048"
            d="M146.45,374.31c-5.39,0-10.07-3.75-11.23-9.02L77.55,103.83c-.7-3.17-.02-6.5,1.86-9.14L143.35,4.83C145.53,1.78,149.04-.06,152.81,0c3.75.03,7.25,1.89,9.38,4.98l61.87,89.85c1.81,2.63,2.45,5.89,1.76,9l-57.73,261.4c-1.16,5.24-5.79,8.99-11.16,9.02l-10.41.06h-.07ZM101.11,103.86l50.54,229.14,50.63-229.24-49.71-72.2-51.45,72.31Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ProposalsIcon;
